const PRISM_MAX_IMAGE_QUALITY = 100;

export {PRISM_MAX_IMAGE_QUALITY};
